import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=1ff55906&scoped=true"
import script from "./InformationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InformationModal.vue?vue&type=style&index=0&id=1ff55906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff55906",
  null
  
)

export default component.exports